import { QuestControlProps } from './index'
import RadioBtn from '../RadioBtn'

interface Props extends QuestControlProps<string> {
  options: Array<{ label: string; value: string }>
  disabled?: boolean
}

const QuestRadioGroupControl = ({
  options,
  disabled,
  onChange,
  value
}: Props) => {
  return (
    <div className={'quest-group-control'}>
      {options.map((option: { label: string; value: string }) => (
        <RadioBtn
          key={option.value}
          name={option.value}
          disabled={disabled}
          value={value}
          onChange={onChange}
          label={option.label}
        ></RadioBtn>
      ))}
    </div>
  )
}

export { QuestRadioGroupControl }
